export default "__VITE_ASSET__I_Xqxk$u__"